import React, { useEffect, useContext } from 'react'
import styled from 'styled-components'
import Context from '../../../setup/context'
import { ButtonRed } from 'styles/buttons'
import { ButtonBlue } from 'pageComponents/SearchResults/uiComponents/itemResult'
import { DivRow } from 'pageComponents/Checkout2/styledComponents'
import { Link } from 'react-router-dom'

const Div = styled.div`
  justify-content: center;
  margin-bottom: 20px;
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 546px;
  height: 250px;
  margin: 200px auto auto auto;
  background-color: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 3px 3px 6px rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
`

const P = styled.p`
  color: black;
  font-size: 15px;
  margin-bottom: .5rem;
`

const OrderList = styled.div`
  margin-bottom: .5rem;
`

const OrderItem = styled(Link)`
  display: block;
`

export default function CartCheckModal({ open, onClose, item, details }) {
    return open && details?.length > 0 && (
        <Div>
            <Container>
                <P>It looks like {item} is currently on an open Quote/Order.</P>
                <P>Would you like to view it?</P>
                <OrderList>
                  {details.slice(0, 3).map(d => <OrderItem to={`/account/${(d.Type).toLowerCase()}-detail/${d.Id}`}>View {d.Type} #{d.Id}</OrderItem>)}
                </OrderList>
                <ButtonRed onClick={onClose}>No, Continue Shopping</ButtonRed>
            </Container>
        </Div>
    )
}
